import { useEffect, useState } from 'react';
import { CardFlow } from '@shared/api';

export const useCardFlow = (value?: CardFlow[] | null, id?: number) => {
  const [cardFlow, setCardFlow] = useState<CardFlow>();

  useEffect(() => {
    if (value && value?.length > 0 && id) {
      const card = value.filter((x) => x.cardId === id);
      if (card.length > 0) {
        setCardFlow(card[0]);
      }
    }
  }, [value]);

  return cardFlow;
};
